var _style, _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPageViews(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F4E8FF;}\n\t.st1{fill:#BF84FE;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 50,
    cy: 50,
    r: 38.9
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.8,44.8c-2.3,0-4.2,2.1-4.2,4.7s1.9,4.7,4.2,4.7c2.4,0,4.2-2.2,4.2-4.7C54,46.8,52.2,44.8,49.8,44.8 L49.8,44.8z M50,35c-11.5,0-21,8.8-21,15c0,6.2,9.4,15,21,15c11.6,0,21-8.9,21-15C71,44,61.6,35,50,35L50,35z M49.9,59.8 c-4.9,0-8.9-4.5-8.9-10c0-5.5,4-10,8.8-10c5,0,9,4.5,9,10C58.8,55.2,54.8,59.8,49.9,59.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageViews);
export default __webpack_public_path__ + "static/media/page-views.2d90664f91ba6bc86993e3e4b5546c11.svg";
export { ForwardRef as ReactComponent };